module.exports = __webpack_public_path__ + "static/media/a1.427e58fa.png";